export enum DisabledState {
  none = 'none',
  untilEndOfDay = 'until_end_of_day',
  indefinitely = 'indefinitely',
}

type PriceType = {
  variant_id: number
  price: number
  disabled?: { state: DisabledState }
}

export type ProductStoreType = {
  prices: PriceType[]
  store_id: number
  product_id: number
  disabled?: {
    state: DisabledState
    any_variants: boolean
    all_variants: boolean
  }
}
